/** Как в `frontend/src/components/Layout.js` — компактные числа в сайдбаре */
export function formatSidebarNumber(num: number): string {
  if (num < 1000) return String(num)
  if (num < 10000) {
    const thousands = num / 1000
    return thousands % 1 === 0 ? `${thousands}к` : `${thousands.toFixed(1)}к`
  }
  if (num < 1000000) return `${Math.round(num / 1000)}к`
  if (num < 10000000) {
    const millions = num / 1000000
    return millions % 1 === 0 ? `${millions}м` : `${millions.toFixed(1)}м`
  }
  return `${Math.round(num / 1000000)}м`
}
